import React from "react";
import { Route, Switch } from 'react-router-dom';  // Enables routing between the components
import CreateTenant from '../../../TenantComponents/ManageTenants/Tenants/CreateTenant/CreateTenant';
import TenantAfterHours from '../../../TenantComponents/ManageTenants/Tenants/CreateTenant/CreateTenant_AfterHours';
import TenantNormalHours from '../../../TenantComponents/ManageTenants/Tenants/CreateTenant/CreateTenant_NormalHours';
import BuildingSubgroups from '../../../TenantComponents/ManageTenants/Tenants/CreateTenant/CreateTenant_Select_Building_Subgroups';
import TenantEmployeeUsers from '../../../TenantComponents/ManageTenants/Tenants/CreateTenant/CreateTenant_Create_EmployeeUsers';
import TenantMeters from '../../../TenantComponents/ManageTenants/Tenants/CreateTenant/CreateTenant_Meters';
import TenantFixedCharges from '../../../TenantComponents/ManageTenants/Tenants/CreateTenant/CreateTenant_FixedCharges';
import ConfirmTenantSettings from '../../../TenantComponents/ManageTenants/Tenants/CreateTenant/CreateTenant_Confirm_Tenant_Settings';
import ViewTenantDetails from '../../../TenantComponents/ManageTenants/Tenants/ViewTenant/ViewTenantTabSystem';

  
const EnsembleMainContainer = ({ match }) =>  {
    return (
        <div>
            <Switch>

               <Route path={'/managetenant/CreateTenant'} component={CreateTenant}/>   
                <Route path={'/managetenant/TenantAfterHours'} component={TenantAfterHours}/>   
                <Route path={'/managetenant/TenantNormalHours'} component={TenantNormalHours}/>   
                <Route path={'/managetenant/BuildingSubgroups'} component={BuildingSubgroups}/>   
                <Route path={'/managetenant/TenantEmployeeUsers'} component={TenantEmployeeUsers}/>   
                <Route path={'/managetenant/TenantMeters'} component={TenantMeters}/>   
                <Route path={'/managetenant/TenantFixedCharges'} component={TenantFixedCharges}/>   
                <Route path={'/managetenant/ConfirmTenantSettings'} component={ConfirmTenantSettings}/>   
                <Route path={'/managetenant/ViewTenantDetails'} component={ViewTenantDetails}/>    
            </Switch>
        </div>  
    );
}

export default EnsembleMainContainer;